import Repository from './Repository'

export default {
  requestTokenWeb (id, params) {
    return Repository.public().get(
      'claim/user/' + id + '/token-web', params
    )
  },
  requestTokenSMS (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/token_sms', params
    )
  },
  requestCodeSMS (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/sms_code', params
    )
  },
  validateCodeSMS (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/validate_sms_code', params
    )
  },
  claimWorkplaceURL (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/wp_url', params
    )
  },
  getPhoneNumber (id, params) {
    return Repository.public().get(
      'claim/user/' + id + '/phone_number', params
    )
  },
  getClaimedStatus (dni, params) {
    return Repository.public().get(
      'claim/user/' + dni + '/claimed_status', params
    )
  },
  getAnswerSecurityStatus (dni, anio, params) {
    return Repository.public().get(
      'claim/user/' + dni + '/anio_number/' + anio, params
    )
  },
  getStatusUser (id, params) {
    return Repository.public().get(
      'claim/user/' + id + '/status_user', params
    )
  },
  getCheckSecurityStatus (id, data, params) {
    return Repository.public().get(
      'claim/user/' + id + '/check_security/' + data, params
    )
  },
  getAccessCode (id, params) {
    return Repository.public().get(
      'claim/user/' + id + '/access-code', params
    )
  },
  postChangeStatusUser (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/change_status', params
    )
  }
}
